const { stuttering, default: onWidthResize } = require('util/onWidthResize');

const { MAIN_EASING, DELAY_DEBOUNCE } = require('util/consts');

const {
	default: { breakMediumSmall, breakMedium, breakLarge, slowDelay },
} = require('util/sass-variables');
const {
	getNumber,
	mediaQueryMin,
	setClass,
	fillWithDomElementsAll,
	trackGtm4,
} = require('util/functions');
const asyncImport = require('util/asyncImport').default;

const delay = getNumber(slowDelay) * 1000;

const CLASS_BACK = 'back';
const CLASS_LEAVING = 'leaving';
const CLASS_COMING = 'coming';
const CLASS_ACTIVE = 'active';
const CLASS_INACTIVE = 'inactive';
const CLASS_TRANSITION = 'transition';
const CLASS_COUNTRIES = 'countries';
const CLASS_CONTINENTS = 'country-info--continent';

const selectorsAll = {
	contriesList: CLASS_COUNTRIES,
	continentsList: CLASS_CONTINENTS,
};

// these are not only but also used as classes, keep it matching css names
const FAX = 'fax';
const MAIL = 'mail';
const PHONE = 'phone'; // classless in css
const prefixes = {
	[PHONE]: 'tel:',
	[FAX]: 'fax:',
	[MAIL]: 'mailto:',
};

function getTarget(list, selection) {
	return list.querySelector(`[data-continent="${selection}"]`);
}
function setTarget(list, selection, active) {
	const target = getTarget(list, selection);
	if (!mediaQueryMin(columnBreak)) {
		if (active) target.classList.add(CLASS_ACTIVE);
		else target.classList.remove(CLASS_ACTIVE);
	} else {
		const firstListElement = [...target.children][0]?.querySelector('a');
		if (active) {
			if (firstListElement) firstListElement.focus();
			target.classList.add(CLASS_ACTIVE);
		} else {
			target.classList.remove(CLASS_ACTIVE);
		}
	}
}

const columnBreak = breakMediumSmall;
const resizeBreak = breakMedium;

module.exports = {
	async init() {
		fillWithDomElementsAll(this, selectorsAll);

		await asyncImport(this, 'anime');
		this.initElements();
		this.initEvents();
		this.initialTitle = this.title.innerHTML;
		// market
		this.market = this.root.dataset.market;
		if (this.market) await this.initMarket();

		if (mediaQueryMin(columnBreak) && !this.market) {
			const defaultContinent = this.continents.querySelector(
				'.country-info--continent',
			);
			this.selectContinent(defaultContinent.dataset.continent);
		}
		this.setHeight();
		setClass(this.root, true, CLASS_ACTIVE);
		setClass(this.loadingOverlay, false, CLASS_ACTIVE);
		this.countryItems.forEach(countryItem => {
			countryItem.addEventListener('click', e => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: 'V3-Market-contact-map',
					widget_title: this.title
						? this.title.innerText
						: 'No title: Title not set',
					link_text: countryItem.innerText.trim(),
					link_url: countryItem.getAttribute('href'),
					button_type: '',
				});
			});
		});
	},
	initElements() {
		this.continents = this.root.querySelector('.country-info--continents');
		this.content = this.root.querySelector('.country-info--content');
		this.title = this.root.querySelector('.country-info--title');
		this.countryList = this.root.querySelector('.country-info--list');
		this.loadingOverlay = this.root.querySelector('.loading-overlay');
		this.countryItems = this.root.querySelectorAll(
			'.countries--country button',
		);
	},
	initEvents() {
		this.continents.addEventListener('click', e => {
			const continent = e.target.dataset.continent;
			if (continent) this.selectContinent(continent);
			this.selectMarket(null);
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: 'V3-Market-contact-map',
				widget_title: this.title
					? this.title.innerText
					: 'No title: Title not set',
				link_text: e.target.innerText,
				link_url: 'No url: Continent selector',
				button_type: '',
			});
		});
		this.title.addEventListener('click', () => {
			if (!mediaQueryMin(columnBreak)) this.selectContinent(null);
		});
		this.contriesList.forEach(element => {
			let countryLinks = element.querySelectorAll('a');
			countryLinks.forEach((link, i) => {
				link.addEventListener('keydown', e => {
					this.continentsList.forEach((continent, index) => {
						if (continent.classList.contains(CLASS_ACTIVE)) {
							if (countryLinks.length - 1 === i && e.keyCode === 9) {
								this.continentsList[
									index + 1 > this.continentsList.length - 1 ? 0 : index
								].focus();
							} else if (i === 0 && e.keyCode === 9) {
								if (e.shiftKey) this.continentsList[index + 1].focus();
							}
						}
					});
				});
			});
		});

		this.continentsList.forEach((continent, index) => {
			continent.addEventListener('keydown', e => {
				if (this.continentsList.length === index + 1 && e.keyCode === 9) {
					setTimeout(() => {
						this.continentsList[0].focus();
					}, 0);
				} else if (
					e.keyCode === 13 &&
					continent.dataset.continent === this.selection
				) {
					setTarget(this.countryList, continent.dataset.continent, true);
					setTarget(this.continents, continent.dataset.continent, true);
				}
			});
		});
		onWidthResize(this.resize.bind(this), stuttering.DEBOUNCE, DELAY_DEBOUNCE);
	},
	resize() {
		this.selectContinent(null);
		this.updateTitle();
		if (this.marketResizeEvent) this.marketResizeEvent();
	},
	updateTitle() {
		if (mediaQueryMin(columnBreak) || !this.selection) {
			this.title.innerHTML = this.initialTitle;
			this.title.classList.remove(CLASS_BACK);
		} else {
			this.title.innerHTML = this.selection;
			this.title.classList.add(CLASS_BACK);
		}
	},
	selectContinent(continent) {
		if (continent !== this.selection) {
			if (this.selection) {
				setTarget(this.countryList, this.selection, false);
				setTarget(this.continents, this.selection, false);
			}
			if (continent) {
				setTarget(this.countryList, continent, true);
				setTarget(this.continents, continent, true);
				this.continents.classList.add(CLASS_ACTIVE);
			} else {
				this.continents.classList.remove(CLASS_ACTIVE);
			}

			this.selection = continent;

			this.setHeight();
			this.updateTitle();
		}
	},
	setHeight() {
		if (mediaQueryMin(this.market ? breakLarge : resizeBreak))
			this.content.style.height = null;
		else {
			let target;
			if (this.selection) target = getTarget(this.countryList, this.selection);
			else target = this.continents;
			let height = target.clientHeight;
			if (height < this.continents.clientHeight)
				height = this.continents.clientHeight;
			const duration = Math.abs(height - this.root.clientHeight);
			height += 50; // padding

			if (this.contentTargetHeight !== height) {
				this.anime({
					targets: this.content,
					easing: MAIN_EASING,
					duration,
					height,
				});
				this.contentTargetHeight = height;
			}
		}
	},

	//
	// ----------- markets ------------------
	//

	async initMarket() {
		try {
			const answer = await fetch(this.market, {
				method: 'GET',
			});
			this.countryMarkets = await answer.json();
			this.content.classList.remove(CLASS_INACTIVE);
			this.initMarketElements();
			this.initMarketsEvents();
			this.initMarketValues();
			if (this.root.dataset.default) this.selectCountryInit();
			this.updateMarketSize();
		} catch (error) {
			console.error(error);
		}
	},
	initMarketElements() {
		this.marketsContainer = this.root.querySelector('.market-pane');
		this.currentPane = this.marketsContainer.querySelector(
			'.market-pane--content',
		);
		this.policy = this.marketsContainer.querySelector(
			'.market-pane--policy',
		).innerHTML;
	},
	initMarketValues() {
		// labels
		this.callLabel = this.marketsContainer.dataset.calllabel;
		this.writeLabel = this.marketsContainer.dataset.writelabel;
		// values
		this.slidingCount = 0;
		this.marketPadding =
			getNumber(
				window
					.getComputedStyle(this.marketsContainer, null)
					.getPropertyValue('padding-top'),
			) * 2;
	},
	selectCountryInit() {
		const [country, continent] = this.root.dataset.default.split('_');
		const button = this.countryList.querySelector('[data-isdefault="true"');
		button.classList.add(CLASS_ACTIVE);
		this.previousCountryButton = button;
		this.selectContinent(continent);
		this.selectMarket(country);
	},
	scrollToMarket() {
		const navHeight = document.querySelector('.nav-layout').offsetHeight;
		const scrollTop =
			this.content.offsetTop + this.contentTargetHeight - navHeight;
		this.anime({
			targets: document.scrollingElement,
			scrollTop,
			easing: MAIN_EASING,
			duration: delay * 2,
		});
	},
	initMarketsEvents() {
		const buttons = this.root.querySelectorAll('.countries--country button');
		buttons.forEach(button => {
			button.addEventListener('click', this.marketClickHandler.bind(this));
		});
		this.marketResizeEvent = () => {
			if (this.previousCountryButton)
				this.previousCountryButton.classList.remove(CLASS_ACTIVE);
			this.selectMarket(null);
			this.updateMarketSize();
		};
	},
	marketClickHandler({ target }) {
		const country = target.innerText;
		if (this.previousCountryButton)
			this.previousCountryButton.classList.remove(CLASS_ACTIVE);
		this.previousCountryButton = target;
		target.classList.add(CLASS_ACTIVE);
		this.selectMarket(country);
		if (!mediaQueryMin(resizeBreak)) this.scrollToMarket();
	},
	updateMarketSize() {
		const height = this.currentPane.offsetHeight + this.marketPadding;
		this.marketsContainer.style.height = height + 'px';
	},
	getMarket(country) {
		return this.countryMarkets[country] || this.countryMarkets.global;
	},
	selectMarket(country) {
		const market = this.getMarket(country);

		if (market && (country || this.previousCountryButton)) {
			const previous = this.currentPane;
			if (previous) this.fadePane(previous);
			this.currentPane = this.renderMarket(market);
			if (previous) this.includePane(this.currentPane);
			this.updateMarketSize();
		}
		if (!country) this.previousCountryButton = null;
	},
	fadePane(pane) {
		pane.classList.add(CLASS_LEAVING);
		setTimeout(() => {
			pane.remove();
			this.slidingCount--;
			if (this.slidingCount <= 0)
				this.marketsContainer.classList.remove(CLASS_TRANSITION);
		}, delay);
	},
	includePane(pane) {
		this.marketsContainer.append(pane);
		window.requestAnimationFrame(() => {
			pane.classList.remove(CLASS_COMING);
		});
		this.marketsContainer.classList.add(CLASS_TRANSITION);
		this.slidingCount++;
	},
	splitPhone(phone) {
		const noteRegEx = /(\([^(]*\)$)|(^[^(]*:[\s]*)/;
		let note = phone.match(noteRegEx);
		let number = phone;
		if (note) {
			note = note[0];
			number = number.replace(note, '');
			note = note.trim().replace(':', '');
		}
		number.trim();
		return [number, note];
	},
	renderLink(phone, kind) {
		const [number, note] =
			kind !== MAIL ? this.splitPhone(phone) : [phone, null];
		let render = `<a href="${prefixes[kind]}${number}" class="link ${kind}"><div>
            <p class="link--number">${number}</p>`;
		if (note) render += `<p class="link--note">${note}</p>`;
		return render + '</div></a>';
	},
	renderCalls({ Telephone1, Telephone2, Fax }) {
		let content = '';
		if (Telephone1 || Telephone2 || Fax) {
			content += `
          <h3 class="market-pane--title">${this.callLabel}</h3><div class="market-pane--phones">`;
			if (Telephone1) content += this.renderLink(Telephone1, PHONE);
			if (Telephone2) content += this.renderLink(Telephone2, PHONE);
			if (Fax) content += this.renderLink(Fax, FAX);
			content += '</div>';
		}
		return content;
	},
	renderSection({ Title, Address, Telephone1, Telephone2, Fax, Mail }) {
		const name = Title.split('_')[2];
		let content = '<div class="market-pane--section">';
		content += this.renderCalls({ Telephone1, Telephone2, Fax });
		if (Address || Mail)
			content += `
          <h3 class="market-pane--title">${this.writeLabel}</h3>`;
		if (name)
			content += `
        <h4 class="market-pane--name">${name}</h4>`;
		if (Mail) content += this.renderLink(Mail, MAIL);
		if (Address)
			content += `
      <address class="market-pane--address">${Address}</address>
      `;

		content += '</div>';
		return content;
	},
	renderMarket(market) {
		const pane = document.createElement('div');
		pane.classList.add('market-pane--content', CLASS_COMING);
		let content = '';
		if (market.length) {
			market.forEach(data => {
				content += this.renderSection(data);
			});
		} else {
			const defaultMessage = this.marketsContainer.dataset.defaultmessage;
			content = `<div class="market-pane--section"><p class="market-pane--address">${defaultMessage}</p></div>`;
		}
		pane.innerHTML = `${content}<div class="market-pane--policy wysiwyg">${this.policy}</div>`;
		return pane;
	},
};
